import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useEnrollResidentStepperStyles = makeStyles({
  activeStep: {
    '& .MuiStepLabel-iconContainer path': {
      fill: palette.primary.dark
    }
  },
  disabledStep: {
    pointerEvents: 'none'
  },
  stepLink: {
    display: 'inline-block',
    textDecoration: 'none'
  },
  stepperWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '10px',
    marginTop: '30px'
  }
});
export default useEnrollResidentStepperStyles;